<template src="../../../components/shared/physicianSearch/BaseSearchBox.html">
</template>

<script>
    import {searchBoxMixin} from "../../../components/shared/mixins/searchBoxMixin.js";
    import {common} from "../../../global/common.js";
    import {api} from "../../../global/framework/api.js";

    export default {
        name: "SearchBox",
        props: {companyId: {type: [Number], required: true}, token: {type: [String], required: true}},
        mixins: [searchBoxMixin],
        data() {
            return {
                entityId: this.companyId
            }
        },
        async mounted() {
            this.baseInit();
            let url = `providerSearch/${this.companyId}/GetAvailableNetworks`;
            url = common.appendUrlParameter(url, 'token', this.token);
            this.availableNetworks = await $.ajax({type: "GET", url});
        },
        methods: {
            generateBaseUrl() {
                let url = `providerSearch/${this.companyId}/byLocation/${this.searchCriteria.latitude}/${this.searchCriteria.longitude}/${this.searchCriteria.radiusId}`;
                url = common.appendUrlParameter(url, 'token', this.token);
                return url;
            },
            searchPhysiciansRedirect() {
                this.$router.push({
                    name: "physicianSearchByLocation", params: {
                        latitude: this.searchCriteria.latitude,
                        longitude: this.searchCriteria.longitude,
                        radiusId: this.searchCriteria.radiusId,
                        companyId: this.companyId,
                        token: this.token
                    },
                    query: {
                        designationId: this.searchCriteria.designationId,
                        //Have to do this because keep in mind that Boolean('false') = true
                        onlyAcceptingNewPatients: this.searchCriteria.onlyAcceptingNewPatients ? 1 : 0,
                        physicianName: this.searchCriteria.physicianName,
                        addressName: this.searchCriteria.addressName,
                        networkId: this.searchCriteria.networkId,
                        planCategoryId: this.searchCriteria.planCategoryId 
                    }
                });
            }
        }

    }
</script>

<style scoped src="../../../components/shared/physicianSearch/SearchBox.css">

</style>